<p-dialog
  [visible]="showMeetingOutcome()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '1199px': '100vw' }"
  (onHide)="setHidePopup()"
  [style]="{ width: '1220px' }"
  styleClass="no-header-modal"
  id="toutoutcomepopup"
  [closeOnEscape]="true"
  aria-label="tour-outcome-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div class="grid m-0" aria-label="tour-outcome-container">
      <!-- left side -->
      <div
        class="col-12 lg:col-4 hidden lg:block surface-100 p-0 border-right-2 border-300"
        aria-label="client-info-section"
      >
        <!-- Header -->
        @if (modelData()?.client_info) {
          <div
            class="bg-blue-50 py-2 px-3 h-3rem md:h-4rem flex align-items-center"
            aria-label="client-status-header"
          >
            <span
              class="bg-green-500 px-2 py-1 line-height-3 font-bold border-round text-white text-xxs"
              aria-label="client-status"
            >
              {{ modelData()?.client_info?.status | uppercase }}</span
            >
            <div
              class="relative mx-2 w-6rem h-2rem overflow-hidden flex align-items-center"
              aria-label="stage-info"
            >
              @if (
                getStageStatus(modelData()?.stage_master_id) | async;
                as strStage
              ) {
                <img
                  src="/assets/img/icons/opportunity-stage-bg.svg"
                  class="absolute w-6rem h-2rem"
                  alt="Stage Background"
                />
                <span
                  class="relative z1 text-xs text-primary font-bold ml-2 w-10 block overflow-hidden text-overflow-ellipsis white-space-nowrap text-ellipsis block line-height-4"
                  aria-label="stage-name"
                >
                  {{ strStage }}
                </span>
              }
            </div>
            <div
              class="relative overflow-hidden flex align-items-center cursor-pointer"
              (click)="goToClientProfile(modelData()?.client_info?.id)"
              aria-label="client-profile-link"
            >
              <span class="w-2rem h-2rem mr-2" aria-label="client-avatar">
                @if (modelData()?.client_info?.image) {
                  <p-avatar
                    [image]="modelData()?.client_info?.image"
                    shape="circle"
                  />
                } @else {
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                  />
                }
                <ng-template #noContactPic1>
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                  />
                </ng-template>
              </span>
              <h3 class="mb-0 text-primary text-base" aria-label="client-name">
                {{ modelData()?.client_info?.full_name }}
              </h3>
              <p
                class="mb-0 text-xs text-600 ml-2 hidden md:block"
                aria-label="client-id"
              >
                - {{ modelData()?.client_info?.id }}
              </p>
            </div>
          </div>
        }
        <!-- Header -->

        @if (modelData()?.client_info) {
          <div
            class="border-top-1 border-bottom-1 border-300 surface-0 p-3 flex align-items-center text-xs"
            aria-label="contact-info-section"
          >
            <div
              class="flex align-items-center mr-5 white-space-nowrap"
              aria-label="phone-info"
            >
              <i class="fa fa-phone mr-3" aria-label="phone-icon"></i>
              <strong aria-label="phone-number"
                >{{ modelData().client_info.mobile_country_code }}
                {{ modelData().client_info.mobile_number }}</strong
              >
            </div>
            <div
              class="flex align-items-center break-word"
              aria-label="email-info"
            >
              <i
                class="fa fa-envelope font-light text-600 mr-2"
                aria-label="email-icon"
              ></i>
              <span class="text-primary" aria-label="email-address">{{
                modelData()?.client_info?.email_id
              }}</span>
            </div>
          </div>
        }
        <div class="p-3" aria-label="task-info-section">
          <app-task-opportunity-info
            [taskOpportunityInfo]="modelData()"
            (ErrorData)="GetErrorData($event)"
            (UpdatedData)="GetUpdatedData($event)"
            aria-label="task-opportunity-info"
          />
        </div>
        <!-- Content -->
      </div>
      <!-- left side -->

      <!-- Right Side -->
      <div
        class="col-12 lg:col-8 p-0 relative pb-8"
        aria-label="outcome-section"
      >
        <!-- Top Area -->
        <!-- Header -->
        <div
          class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
          aria-label="outcome-header"
        >
          <h2 class="mb-0 text-base" aria-label="outcome-title">
            {{ 'OUTCOME.TOUROUTCOME.HOW-DID-MEETING-GO' | translate }}
          </h2>
          <div
            class="fa fa-times text-xl text-600 cursor-pointer"
            (click)="setHidePopup()"
            aria-label="close-dialog-button"
            data-testid="close-dialog-button"
          ></div>
        </div>
        <!-- Header -->

        <!-- Dropdown -->
        <div class="relative z-1" aria-label="mobile-client-info">
          <div
            class="bg-blue-50 flex align-items-center justify-content-between py-2 px-3 h-3rem md:h-4rem border-bottom-1 border-300 lg:hidden"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="scalein"
            leaveToClass="hidden"
            leaveActiveClass="fadeout"
            aria-label="mobile-client-header"
          >
            <div
              class="flex align-items-center my-1 cursor-pointer"
              (click)="goToClientProfile(modelData()?.client_info?.id)"
              aria-label="mobile-client-profile-link"
            >
              <span class="mr-2">
                @if (modelData()?.client_info?.image) {
                  <img
                    [src]="modelData()?.client_info?.image"
                    class="border-circle"
                    width="32"
                    alt="Avatar"
                  />
                } @else {
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                  />
                }
                <ng-template #noContactPic2>
                  <p-avatar
                    [label]="
                      modelData()?.client_info?.full_name
                        | titlecase
                        | shortName
                    "
                    shape="circle"
                  />
                </ng-template>
              </span>
              <span
                class="text-primary font-bold text-lg mr-2"
                aria-label="mobile-client-name"
                >{{ modelData()?.client_info?.full_name }}</span
              >
              <span
                class="text-600 font-normal text-sm"
                aria-label="mobile-client-id"
                >{{ modelData()?.client_info?.id }}</span
              >
            </div>
            <div
              class="flex align-items-center"
              aria-label="mobile-client-status"
            >
              <div [innerHTML]="clientStatus(modelData()?.client_info)"></div>
              <!-- <span
              class="bg-red px-2 py-1 font-bold border-round text-white text-xxs">{{modelData.client_info.status
            | uppercase}}</span> -->
              <i
                class="fa fa-circle-chevron-down text-xl ml-2 text-primary"
                aria-label="status-dropdown-icon"
              ></i>
            </div>
          </div>

          <div
            class="surface-50 p-0 m-0 border-round shadow-0 lg:shadow-2 lg:absolute hidden origin-top w-full"
            aria-label="mobile-task-info"
          >
            <!-- Content -->
            <div class="p-3" aria-label="mobile-task-details">
              <app-task-opportunity-info
                [taskOpportunityInfo]="modelData()"
                (ErrorData)="GetErrorData($event)"
                (UpdatedData)="GetUpdatedData($event)"
                aria-label="mobile-task-opportunity-info"
              />
            </div>
            <!-- Content -->
          </div>
        </div>
        <!-- Dropdown -->

        <!-- Content -->

        <div class="p-3" aria-label="outcome-selection-section">
          <h6
            class="text-xs font-normal mb-0 text-600"
            aria-label="outcome-label"
          >
            {{ 'OUTCOME.TOUROUTCOME.MEETING-OUTCOME' | translate }}
          </h6>

          <div class="p-buttonset hidden lg:block" aria-label="outcome-buttons">
            @for (item of outcome; track item; let i = $index) {
              <button
                pButton
                pRipple
                class="text-sm mt-2"
                (click)="SelectOutcome(item)"
                label="{{ item.name }}"
                icon="{{ item.icon }}"
                [ngClass]="
                  selectedOutcome === item ? item.class : 'p-button-secondary'
                "
                [attr.aria-label]="'outcome-button-' + item.name"
              ></button>
            }
          </div>

          <div
            class="block lg:hidden mt-2"
            aria-label="mobile-outcome-dropdown"
          >
            <p-select
              placeholder="Select"
              [options]="outcome"
              (onChange)="SelectOutcomeMob($event)"
              optionLabel="name"
              styleClass="w-full"
              aria-label="outcome-select"
            >
              <ng-template pTemplate="selectedItem">
                @if (selectedOutcome) {
                  <div class="flex align-items-center">
                    <span class="mr-2"
                      ><i
                        style="color:'{{ selectedOutcome.iconColor }}'"
                        class="{{ selectedOutcome.icon }}"
                      ></i
                    ></span>
                    <strong>{{ selectedOutcome.name }}</strong>
                  </div>
                }
              </ng-template>
              <ng-template let-outcome pTemplate="item">
                <div class="flex align-items-center">
                  <span class="mr-2"
                    ><i
                      style="color:'{{ outcome.iconColor }}'"
                      class="{{ outcome.icon }}"
                    ></i
                  ></span>
                  <div class="text-sm text-600">{{ outcome.name }}</div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>

        <!-- Info Box -->
        <div
          class="surface-100 p-3 flex align-items-center"
          aria-label="info-box"
        >
          <i class="fa fa-info-circle text-600" aria-label="info-icon"></i>
          <span class="text-xs text-600" aria-label="info-text">
            {{ 'OUTCOME.TOUROUTCOME.MEETING-OUTCOME-ABOUT' | translate }}
          </span>
        </div>
        <!-- Info Box -->

        <!-- Choose Your Outcome -->
        <ng-container
          *ngTemplateOutlet="selectedOutcome ? getoutcome : chooseoutcome"
        />
        <!-- Choose Your Outcome -->

        <!-- Top Area -->
      </div>
      <!-- Right Side -->
    </div>
    <!-- </form> -->
  </ng-template>
  <ng-template #chooseoutcome>
    <div class="p-3" aria-label="choose-outcome-section">
      <div class="p-3 text-center">
        <h2 class="mb-6 text-lg md:text-2xl" aria-label="choose-outcome-title">
          {{ 'OUTCOME.TOUROUTCOME.CHOOSEOUTCOME' | translate }}
        </h2>
        <img
          width="260"
          src="assets/img/call-outcome-img.svg"
          alt="Image"
          aria-label="outcome-illustration"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #notintrested let-form="form">
    <form
      [formGroup]="TourOutComeNotIntrestedForm"
      (ngSubmit)="MarkTourOutComeNotIntrested(TourOutComeNotIntrestedForm)"
      aria-label="not-interested-form"
    >
      <div class="p-3" aria-label="not-interested-content">
        <h5
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="notes-label"
        >
          {{ 'OUTCOME.TOUROUTCOME.NOTES' | translate }}
        </h5>
        <textarea
          formControlName="comments"
          pInputTextarea
          class="w-full h-8rem"
          aria-label="notes-input"
        ></textarea>
        @if (
          this.TourOutComeNotIntrestedForm.get('comments').touched &&
          this.TourOutComeNotIntrestedForm.get('comments').invalid
        ) {
          <app-error-msg
            [errors]="this.TourOutComeNotIntrestedForm.get('comments').errors"
            [fieldLabel]="'OUTCOME.TOUROUTCOME.NOTES' | translate"
            aria-label="notes-error"
          />
        }

        <div class="flex align-items-center justify-content-between">
          <div class="w-6">
            <p-button
              label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
              styleClass="p-button-link text-sm"
              (click)="setHidePopup()"
              aria-label="not-interested-cancel-button"
            />
          </div>
          <div class="w-6 text-right">
            <button
              pButton
              pRipple
              label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
              type="submit"
              class="text-sm"
              aria-label="not-interested-submit-button"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #noshow>
    <form
      [formGroup]="TourOutComeNoShowForm"
      (ngSubmit)="MarkTourOutComeNoShow(TourOutComeNoShowForm)"
      id="touroutcomenoshow"
      aria-label="no-show-form"
    >
      <div class="p-3" aria-label="no-show-content">
        <h5
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="notes-label"
        >
          {{ 'OUTCOME.TOUROUTCOME.NOTES' | translate }}
        </h5>
        <textarea
          formControlName="comments"
          pInputTextarea
          class="w-full h-8rem"
          aria-label="notes-input"
        ></textarea>
        @if (
          this.TourOutComeNoShowForm.get('comments').touched &&
          this.TourOutComeNoShowForm.get('comments').invalid
        ) {
          <app-error-msg
            [errors]="this.TourOutComeNoShowForm.get('comments').errors"
            [fieldLabel]="'OUTCOME.TOUROUTCOME.NOTES' | translate"
            aria-label="notes-error"
          />
        }
      </div>

      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full flex align-items-center justify-content-between"
        aria-label="no-show-footer"
      >
        <p-button
          label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
          styleClass="p-button-link text-sm"
          (click)="setHidePopup()"
          aria-label="no-show-cancel-button"
        />
        <button
          pButton
          pRipple
          label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
          type="submit"
          class="text-sm"
          aria-label="no-show-submit-button"
        ></button>
      </div>
    </form>
  </ng-template>

  <ng-template #reschedule>
    <form
      [formGroup]="TourOutComeRescheduleForm"
      (ngSubmit)="RescheduleTouroutcome(TourOutComeRescheduleForm)"
      id="touroutcomreschedule"
      aria-label="reschedule-form"
    >
      <div class="p-3" aria-label="reschedule-content">
        <!-- <div class="flex align-items-center mb-4">
      <p-toggleSwitch formControlName="taskcompleted" (onChange)="clickMarkcompletedChecked($event)"></p-toggleSwitch>
      <h5 class="text-sm mb-0 ml-3 -mt-1 font-normal">{{'OUTCOME.TOUROUTCOME.MARKTASKCOMPLETED' | translate}}</h5>
    </div> -->

        <div class="grid" aria-label="reschedule-section">
          <div class="col-12 py-0">
            <h5
              class="text-xs text-600 font-normal mb-0 uppercase"
              aria-label="reschedule-label"
            >
              {{ 'OUTCOME.TOUROUTCOME.RESCHEDULE' | translate }}
            </h5>
          </div>
          <div class="col-12 md:col-4">
            <div class="p-inputgroup relative cursor-pointer">
              <p-datepicker
                [showIcon]="true"
                dateFormat="dd-M-yy"
                formControlName="rescheduleDate"
                placeholder="Select Date"
                inputStyleClass="text-sm"
                aria-label="reschedule-date-picker"
              />
            </div>
            @if (
              this.TourOutComeRescheduleForm.get('rescheduleDate').touched &&
              this.TourOutComeRescheduleForm.get('rescheduleDate').invalid
            ) {
              <app-error-msg
                [errors]="
                  this.TourOutComeRescheduleForm.get('rescheduleDate').errors
                "
                [fieldLabel]="
                  'OUTCOME.TOUROUTCOME.SELECT-RESCHEDULE-DATE-NEW' | translate
                "
                aria-label="reschedule-date-error"
              />
            }
          </div>
          <div class="col-12 md:col-4 mt-1 md:mt-0">
            <p-datepicker
              [showIcon]="true"
              icon="fa fa-clock"
              hourFormat="12"
              [timeOnly]="true"
              inputId="timeonly"
              formControlName="followupTime"
              placeholder="Select Time"
              StyleClass="text-sm"
              inputStyleClass="text-sm"
              aria-label="reschedule-time-picker"
            />
            @if (
              this.TourOutComeRescheduleForm.get('followupTime').touched &&
              this.TourOutComeRescheduleForm.get('followupTime').invalid
            ) {
              <app-error-msg
                [errors]="
                  this.TourOutComeRescheduleForm.get('followupTime').errors
                "
                [fieldLabel]="
                  'OUTCOME.TOUROUTCOME.SELECT-RESCHEDULE-TIME' | translate
                "
                aria-label="reschedule-time-error"
              />
            }
          </div>
          <div class="col-12 mt-2">
            <h5
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="notes-label"
            >
              {{ 'OUTCOME.TOUROUTCOME.NOTES' | translate }}
            </h5>
            <textarea
              pInputTextarea
              formControlName="comments"
              class="w-full"
              aria-label="notes-input"
            ></textarea>
            @if (
              this.TourOutComeRescheduleForm.get('comments').touched &&
              this.TourOutComeRescheduleForm.get('comments').invalid
            ) {
              <app-error-msg
                [errors]="this.TourOutComeRescheduleForm.get('comments').errors"
                [fieldLabel]="'OUTCOME.TOUROUTCOME.NOTES' | translate"
                aria-label="notes-error"
              />
            }
          </div>
        </div>

        <div
          class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full flex align-items-center justify-content-between"
          aria-label="reschedule-footer"
        >
          <p-button
            label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
            styleClass="p-button-link text-sm"
            (click)="setHidePopup()"
            aria-label="reschedule-cancel-button"
          />
          <button
            pButton
            pRipple
            label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
            type="submit"
            class="text-sm"
            aria-label="reschedule-submit-button"
          ></button>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #stillthinking>
    <form
      [formGroup]="TourOutComeStillThinkingForm"
      (ngSubmit)="MarkTourOutComeStillThinking(TourOutComeStillThinkingForm)"
      id="touroutcomestillthinking"
      aria-label="still-thinking-form"
    >
      <div class="p-3" aria-label="still-thinking-content">
        <h5
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="notes-label"
        >
          {{ 'OUTCOME.TOUROUTCOME.NOTES' | translate }}
        </h5>
        <textarea
          formControlName="comments"
          pInputTextarea
          class="w-full h-8rem"
          aria-label="notes-input"
        ></textarea>
        @if (
          this.TourOutComeStillThinkingForm.get('comments').touched &&
          this.TourOutComeStillThinkingForm.get('comments').invalid
        ) {
          <app-error-msg
            [errors]="this.TourOutComeStillThinkingForm.get('comments').errors"
            [fieldLabel]="'OUTCOME.TOUROUTCOME.NOTES' | translate"
            aria-label="notes-error"
          />
        }
      </div>

      <div
        class="px-4 py-3 border-top-1 border-400 absolute right-0 bottom-0 w-full flex align-items-center justify-content-between"
        aria-label="still-thinking-footer"
      >
        <p-button
          label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
          styleClass="p-button-link text-sm"
          (click)="setHidePopup()"
          aria-label="still-thinking-cancel-buttonnking-cancel-button"
        />
        <button
          pButton
          pRipple
          label="{{ 'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate }}"
          type="submit"
          class="text-sm"
          aria-label="still-thinking-submit-button"
        ></button>
      </div>
    </form>
  </ng-template>
</p-dialog>

@if (showPaidFullSidebar) {
  <billing
    [visible]="showPaidFullSidebar"
    (onHide)="closeDialog()"
    [billedAtTenantId]="tenantId"
    [planSummarydata]="planSummarydataObject$"
    [showbilling]="showPaidFullSidebar"
    closeOnEscape="false"
    (closeSidePopupMember)="hideBillingSummary($event)"
    (GoToClientSubscription)="GoToClientDetails($event)"
    aria-label="billing-sidebar"
  />
}

@if (showErrorPopup | async; as showPopup) {
  <app-errors
    [visible]="showPopup"
    (onHide)="closeDialog()"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-popup"
  />
}

@if (showChooseReason) {
  <app-lost-deal
    [showDailog]="showChooseReason"
    (closeMainDailog)="closeDailog()"
    [lostDealInfo]="lostDealItemInfo"
    aria-label="lost-deal-dialog"
  />
}
